import { render, staticRenderFns } from "./OneStepGroup.vue?vue&type=template&id=f448b8ec&"
import script from "./OneStepGroup.vue?vue&type=script&lang=js&"
export * from "./OneStepGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports